import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

import { type Key } from '@hh.ru/magritte-common-keyboard/keys';

export const keyboardMatch = (event: KeyboardEvent | ReactKeyboardEvent, { key, code }: Key): boolean => {
    return event.key === key || event.code === code;
};

export const keyboardMatches = (event: KeyboardEvent | ReactKeyboardEvent, keysToMatch: Key[]): boolean => {
    for (let i = 0; i < keysToMatch.length; i++) {
        if (keyboardMatch(event, keysToMatch[i])) {
            return true;
        }
    }
    return false;
};
